"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { ArrowRight, Shield, Brain, Scale, FileCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PrivacyEAI() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const complianceItems = [{
    id: "item-1",
    title: "Valutazione d'Impatto (DPIA)",
    content: "Eseguiamo analisi del rischio granulari per sistemi di apprendimento automatico, garantendo che ogni implementazione tecnologica rispetti i diritti fondamentali e i parametri di sicurezza stabiliti dal GDPR.",
    icon: <Shield className="w-5 h-5 text-[var(--ring)]" />
  }, {
    id: "item-2",
    title: "Trasparenza Algoritmica (XAI)",
    content: "Sviluppiamo protocolli legali per l'explainability, assicurando che le logiche decisionali dei modelli AI siano documentate, verificabili e conformi ai requisiti di trasparenza verso gli interessati.",
    icon: <Brain className="w-5 h-5 text-[var(--ring)]" />
  }, {
    id: "item-3",
    title: "Governance e Mitigazione Bias",
    content: "Audit tecnici e legali sui dataset di addestramento per identificare distorsioni algoritmiche. Implementiamo framework di governance per assicurare l'equità e l'integrità dei dati lungo tutto il ciclo di vita dell'AI.",
    icon: <Scale className="w-5 h-5 text-[var(--ring)]" />
  }, {
    id: "item-4",
    title: "Conformità all'EU AI Act",
    content: "Consulenza strategica per la classificazione dei rischi e l'adempimento dei nuovi obblighi europei. Vi guidiamo nella gestione della conformità normativa per operare con sicurezza nel mercato globale.",
    icon: <FileCheck className="w-5 h-5 text-[var(--ring)]" />
  }];
  return;
}